<template>
  <v-dialog
    :value="visiblePopup"
    :max-width="750"
    @click:outside="onCloseClickButton"
    @keydown.esc="onCloseClickButton"
  >
    <v-card class="validate-domain-popup popup-wrapper">
      <div class='close-button-section'>
        <span class='close_btn' @click='onCloseClickButton'>
          <span class="material-icons-outlined">
            close
          </span>
        </span>
      </div>
      <div class='title'> {{ title }} </div>
      <div class='message' v-if='!isAlreadyValidated'> {{ $t('validate.domain.popup.message') }} </div>
      <div class='type-record'>
        <span class='label'> {{ $t('validate.domain.popup.type.label') }} </span>
        <span class='type'>
          {{ recordType }}
        </span>
      </div>
      <div class='txt-record'>
        <span class='label'> {{ $t('validate.domain.popup.name.label') }} </span>
        <span class='value-section'>
          <span class='txt' id='record-name'>
            <v-text-field
              v-model="txtRecord"
              solo-inverted
              readonly
              dense
              flat
            />
          </span>
          <span class='copy material-icons-outlined' @click='copyRecordValue("record-name")'> copy </span>
        </span>
      </div>
      <div class='value-record'>
        <span class='label'> {{ $t('validate.domain.popup.value.label') }} </span>
        <span class='value-section'>
          <span id='record-value' class='value'>
            <v-text-field
              v-model="valueRecord"
              solo-inverted
              readonly
              dense
              flat
            />
          </span>
          <span class='copy material-icons-outlined' @click='copyRecordValue("record-value")'> copy </span>
        </span>
      </div>
      <div class='actions' v-if='!isAlreadyValidated'>
        <div v-if='validated' class='validated-successfully'>
          <span class='label'> {{ $t('validated.successfully.label') }} </span>
          <span class='verified material-icons-outlined'> verified </span>
        </div>
        <div class='validation-failed' v-else-if='validationFailed'>
          <span class='label'> {{ $t('validation.failed.label') }} </span>
          <span class='block material-icons-outlined'> block </span>
        </div>
        <div class='btn-section'>
          <v-btn small depressed class="validate-button" :disabled="loadingValidation || validated" :loading="loadingValidation" @click="onValidateClickButton()">
            {{ validateButtonCaption }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'ValidateDomainPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    visiblePopup: {
      type: Boolean,
      required: true,
    },
    website: Object,
    validationFailed: Boolean,
  },
  computed: {
    ...mapGetters(['loadingValidation', 'configurationDomains', 'domains']),
    title() {
      return this.isAlreadyValidated ? this.$t('validate.domain.popup.title.validated') : this.$t('validate.domain.popup.title.not.validated');
    },
    valueRecord() {
      return this.website.uuid;
    },
    isAlreadyValidated() {
      return this.website.validated;
    },
    recordType() {
      return this.$t('validate.domain.popup.type.value');
    },
    validateButtonCaption() {
      return this.$t('validate.domain.popup.validate.button');
    },
    txtRecord() {
      return this.$t('validate.domain.popup.name.value');
    },
    validated() {
      return this.configurationDomains.find(domain => domain.uuid === this.valueRecord && domain.validated === true) !== undefined;
    },
  },
  methods: {
    async onValidateClickButton() {
      await this.$emit('validate');
    },
    copyRecordValue(id) {
      const r = document.createRange();
      r.selectNode(document.getElementById(id));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(r);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
    },
    async onCloseClickButton() {
      await this.$emit('close');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.validate-domain-popup {
  .validation-failed {
    padding-top: rem(20);
    display: flex;
    align-items: center;
    .label {
      font-family: $font-family-semibold;
      font-size: rem(12);
      letter-spacing: rem(1.1);
    }
    .block {
      &.material-icons-outlined {
        font-size: rem(20);
        opacity: 0.8;
        color: var(--status-error);
      }
    }
  }
  .validated-successfully {
    padding-top: rem(20);
    display: flex;
    align-items: center;
    .label {
      font-family: $font-family-semibold;
      font-size: rem(12);
      letter-spacing: rem(1.1);
    }
    .verified {
      z-index: 5;
      &.material-icons-outlined {
        font-size: rem(18);
        opacity: 0.8;
        color: var(--severity-low)
      }
    }
  }
  .label {
    font-family: $font-family-semibold;
    font-size: rem(12);
    letter-spacing: rem(1.1);
  }
  &.popup-wrapper {
    max-width: rem(750);
    padding: rem(32) rem(40);
    display: flex;
    flex-direction: column;
    .close-button-section {
      z-index: 2;
      .close_btn {
        float: right;
        &:hover {
          cursor: pointer;
          color: var(--brand-primary);
        }
      }
    }
    .title {
      margin-top: rem(-28);
      padding-bottom: rem(35);
      color: var(--text-primary);
      font-family: $font-family-bold;
      font-size: rem(24);
      font-weight: bold;
      line-height: rem(20);
      letter-spacing: 0;
    }

    .message {
      font-size: $font-size-base !important;
      line-height: 1.36 !important;
      font-weight: normal;
      color: var(--text-primary);
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: rem(18);
      margin-bottom: rem(10);
    }

    .type-record {
      display: flex;
      margin-bottom: rem(15);
      .type {
        font-size: rem(12);
        font-weight: bolder;
        margin-left: rem(12);
        margin-right: rem(5);
      }
    }

    .txt-record {
      display: flex;
      margin-bottom: rem(15);
      align-items: baseline;
      .value-section {
        align-items: flex-start;
        display: flex;
        .txt {
          margin-left: rem(5);
          margin-right: rem(5);
        }
        .copy {
          &.material-icons-outlined {
            font-size: rem(18);
            margin-top: rem(7);
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }

    .value-record {
      display: flex;
      align-items: baseline;
      .value-section {
        align-items: flex-start;
        display: flex;
        .value {
          margin-left: rem(6);
          margin-right: rem(5);
        }
        .copy {
          &.material-icons-outlined {
            margin-top: rem(7);
            font-size: rem(18);
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-top: rem(30);
      .validation-failed {
        margin-right: 25%;
      }
      .validated-successfully {
        margin-right: 30%;
      }
      .btn-section {
        display: flex;
        justify-content: flex-end;
        .validate-button {
          height: rem(32);
          width: rem(79);
          border-radius: $radius-sm;
          background-color: var(--brand-primary) !important;
          box-shadow: 0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12),
          0 1px 3px 0 rgba(0,0,0,0.2) !important;

          font-size: rem(12);
          font-weight: 500;
          letter-spacing: rem(1.07);
          line-height: rem(16);
          text-align: center;

          margin-left: rem(8);
        }
      }
    }
  }
}
</style>
<style lang='scss'>
@import '~@/assets/styles/design-system';
.validate-domain-popup {
  .btn-section {
    .validate-button {
      .v-btn__content {
        color: var(--text-on-brand) !important;
      }
      .v-btn__loader {
        color: var(--text-on-brand) !important;
        .v-progress-circular {
          color: var(--text-on-brand) !important;
        }
      }
    }
  }
  .txt-record {
    .v-text-field {
      margin-top: 0px !important;
      height: rem(10);
      font-size: rem(12);
    }
    .v-text-field.v-text-field--solo .v-input__control {
      min-height: rem(20) !important;
    }
    .v-input__slot {
      min-width: rem(110);
      max-width: rem(110);
    }
  }
  .value-record {
    .v-text-field {
      margin-top: 0px !important;
      height: rem(10);
      font-size: rem(12);
    }
    .v-text-field.v-text-field--solo .v-input__control {
      min-height: rem(20) !important;
    }
    .v-input__slot {
      min-width: rem(280);
    }
  }
}
</style>
